import { render, staticRenderFns } from "./NotAccepted.vue?vue&type=template&id=213f8a97&scoped=true&"
import script from "./NotAccepted.vue?vue&type=script&lang=ts&"
export * from "./NotAccepted.vue?vue&type=script&lang=ts&"
import style0 from "./NotAccepted.vue?vue&type=style&index=0&id=213f8a97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f8a97",
  null
  
)

export default component.exports